module.exports = __webpack_public_path__ + "static/media/SimDeactivationInactive.f77b3bd3.svg";